import React, {Component} from 'react'
import PropTypes from 'prop-types'

class LabelColumn extends Component {
    render() {
        const {labelDetails} = this.props
        const {'partnerTrackingNumber': orderTrackingNumber, 'url': orderTrackingUrl} = Object.assign({}, {'partnerTrackingNumber': ''}, labelDetails)

        return <td className="Label">
            <a href={orderTrackingUrl} target='_blank' rel="noopener noreferrer" className='mr-1'>
                {orderTrackingNumber}
            </a>
        </td>
    }
}

LabelColumn.propTypes = {
    labelDetails: PropTypes.object
}

export default LabelColumn